import { configureStore } from '@reduxjs/toolkit';

import setMenuReducer from './slices/menuSlice';
import setGroupsReducer from './slices/groupsSlice';
import setClientsReducer from './slices/clientsSlice';
import setShowMenuSlice from './slices/showMenuSlice';
import setShowPopupStatisticsSlice from './slices/showPopupStatisticsSlice';
import setControSlice from './slices/controlSlice';
import setUserSlice from './slices/userSlice';
import setMeasurementsSlice from './slices/measurementsSlice';

export const store = configureStore({
  reducer: {
    menu: setMenuReducer,
    groups: setGroupsReducer,
    clients: setClientsReducer,
    showMenu: setShowMenuSlice,
    showPopupStatistics: setShowPopupStatisticsSlice,
    control: setControSlice,
    measurements: setMeasurementsSlice,
    user: setUserSlice,
  },
});
